module.exports = __webpack_public_path__ + "assets/bonus.5a4b54b2.svg";